import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function AltaPrecioCategoria({ open, onClose }) {
  const [sucursales, setSucursales] = useState([]);
  const [productos, setProductos] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);

  const [datosRow, setDatosRow] = useState({
    id_sucursal: "",
    id_producto: "",
    id_tipocliente: "",
    precio_minimo: "",
    precio_maximo: "",
  });

  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);

  useEffect(() => {
    const sucAuth = localStorage.getItem("suc_auth");
    getData(`/sucursales/xsucauth/${sucAuth}`, setSucursales);
    getData("/productos/envasados", setProductos);
    getData("/tipoclienteenvasado", setTiposCliente);
  }, []);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
    if (exito) handleClose();
  };

  const validarNumero = (value) => /^\d*\.?\d*$/.test(value);

  const almacenar = (e) => {
    const { name, value } = e.target;
    if (
      (name === "precio_minimo" || name === "precio_maximo") &&
      !validarNumero(value)
    ) {
      return;
    }
    setDatosRow({ ...datosRow, [name]: value });
  };

  const guardar = async (e) => {
    e.preventDefault();

    if (
      !datosRow.id_sucursal ||
      !datosRow.id_producto ||
      !datosRow.id_tipocliente
    ) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Seleccione sucursal, producto y tipo de cliente.");
      setOpenSnack(true);
      return;
    }

    const min = parseFloat(datosRow.precio_minimo);
    const max = parseFloat(datosRow.precio_maximo);
    if (isNaN(min) || isNaN(max)) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Ingrese precio mínimo y máximo válidos.");
      setOpenSnack(true);
      return;
    }
    if (min > max) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("El precio mínimo no puede ser mayor al máximo.");
      setOpenSnack(true);
      return;
    }

    setDisBtn(true);
    try {
      const res = await fetch(UrlApi + "/envasado_rango_categorias", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_sucursal: datosRow.id_sucursal,
          id_producto: datosRow.id_producto,
          id_tipocliente: datosRow.id_tipocliente,
          precio_minimo: min,
          precio_maximo: max,
          usuario: localStorage.getItem("user"),
        }),
      });
      const data = await res.json();

      if (res.ok && data.message === "OK") {
        setExito(true);
        setColorMensaje("#D4EFDF");
        setMensaje("El rango se guardó exitosamente !");
        setOpenSnack(true);
      } else {
        setExito(false);
        setColorMensaje("#F1948A");
        setMensaje(data.message || "Error al guardar el rango.");
        setOpenSnack(true);
        setDisBtn(false);
      }
    } catch (err) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Error al conectar con la base de datos.");
      setOpenSnack(true);
      setDisBtn(false);
    }
  };

  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Rango de Precios por Categoría
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardar}>
          <DialogContent>
            <Grid container spacing={2} mt={0.5}>
              <Grid item xs={12} sm={4}>
                <Autocomplete
                  size="small"
                  options={sucursales}
                  getOptionLabel={(o) => o.nombre ?? ""}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  value={
                    sucursales.find((s) => s.id === datosRow.id_sucursal) || null
                  }
                  onChange={(_, value) =>
                    setDatosRow({
                      ...datosRow,
                      id_sucursal: value ? value.id : "",
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sucursal"
                      focused
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Autocomplete
                  size="small"
                  options={productos}
                  getOptionLabel={(o) => o.nombre ?? ""}
                  isOptionEqualToValue={(o, v) => o.idproducto === v.idproducto}
                  value={
                    productos.find(
                      (p) => p.idproducto === datosRow.id_producto
                    ) || null
                  }
                  onChange={(_, value) =>
                    setDatosRow({
                      ...datosRow,
                      id_producto: value ? value.idproducto : "",
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Producto"
                      focused
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Autocomplete
                  size="small"
                  options={tiposCliente}
                  getOptionLabel={(o) => o.descripcion ?? ""}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  value={
                    tiposCliente.find(
                      (t) => t.id === datosRow.id_tipocliente
                    ) || null
                  }
                  onChange={(_, value) =>
                    setDatosRow({
                      ...datosRow,
                      id_tipocliente: value ? value.id : "",
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tipo de Cliente"
                      focused
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Precio Mínimo"
                  name="precio_minimo"
                  size="small"
                  focused
                  required
                  fullWidth
                  value={datosRow.precio_minimo}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Precio Máximo"
                  name="precio_maximo"
                  size="small"
                  focused
                  required
                  fullWidth
                  value={datosRow.precio_maximo}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={2}
            >
              <Button
                color="error"
                variant="outlined"
                onClick={handleClose}
                style={{ backgroundColor: "#fff" }}
              >
                Volver
              </Button>
              <Button
                type="submit"
                color="success"
                variant="contained"
                disabled={disBtn}
              >
                Guardar
              </Button>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={exito ? "success" : "error"}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AltaPrecioCategoria;
